
// GoScript mode description for CodeMirror

export const GOSCRIPT_MODE = {
    // The start state contains the rules that are initially used
    start: [
        // The regex matches the token, the token property contains the type
        {
            regex: /"(?:[^\\]|\\.)*?(?:"|$)/,
            token: "string"
        },
        // You can match multiple tokens at once. Note that the captured
        // groups must span the whole string in this case
        {
            regex: /(def)(\s+)(.*)(\:)/,
            token: ["def", null, "attribute", "operator"]
        },
        {
            regex: /(def)(\s+)(.*\:?)/,
            token: ["def", null, "attribute"]
        },
        // Rules are matched in the order in which they appear, so there is
        // no ambiguity between this one and the one above
        {
            regex: /((?:go|wait for|hover|click|js|if|else|pause|wait|fail|label|goto|clear|type|scope|focus tab|focus frame|press|set file|file|set tab mode|set max tabs|set mode|url|method|add header|payload|set follow redirects))(\:)(\s+)(.*)\b/,
            token: ["keyword", "operator", null, "string"]
        },
        // NO_ARG_COMMANDS
        {
            regex: /^\s*(reset tabs|exit|new request|send request)\s*$/i,
            token: "keyword"
        },
        // LITERAL_BLOCK_COMMANDS
        {
            regex: /^\s*(add header|payload|js)(:)\s*$/i,
            token: ["keyword", "operator"]
        },
        {
            regex: /(\w*)(\s+=\s+)(\{.*\})$/,
            token: ["variable", null, "link"]
        },
        {
            regex: /(\w*)(\s+=\s+)(.*)$/,
            token: ["variable", null, "string"]
        },
        {
            regex: /null|undefined/,
            token: "atom"
        },
        {
            regex: /0x[a-f\d]+|[-+]?(?:\.\d+|\d+\.?\d*)(?:e[-+]?\d+)?/i,
            token: "number"
        },
        {
            regex: /\#.*/,
            token: "comment"
        },
        {
            regex: /\/(?:[^\\]|\\.)*?\//,
            token: "variable-3"
        },
        // A next property will cause the mode to move to a different state
        {
            regex: /\/\*/,
            token: "comment",
            next: "comment"
        },
        {
            regex: /[-+\/*=<>!\:]+/,
            token: "operator"
        },
        // indent and dedent properties guide autoindentation
        {
            regex: /[\{\[\(]/,
            indent: true
        },
        {
            regex: /[\}\]\)]/,
            dedent: true
        },

        //{
        //  regex: /[a-z$][\w$]*/,
        //  token: "variable"
        //},
        // You can embed other modes with the mode property. This rule
        // causes all code between << and >> to be highlighted with the XML
        // mode.
        {
            regex: /\$apck/,
            token: "meta",
            mode: {
                spec: "javascript",
                end: /$/
            }
        }
    ],
    comment: [
        { regex: /.*?\*\//, token: "comment", next: "start" },
        { regex: /.*/, token: "comment" }
    ],
    // The meta property contains global information about the mode. It
    // can contain properties like lineComment, which are supported by
    // all modes, and also directives like dontIndentStates, which are
    // specific to simple modes.
    meta: {
        dontIndentStates: ["comment"],
        lineComment: "//"
    }
}